import { userInfoSync } from 'hub-http/userInfo';
export default function scopePresent(scope) {
  try {
    const auth = userInfoSync();
    return auth && auth.user.scopes.includes(scope);
  } catch (e) {
    console.error('Failed to get auth payload from userInfoSync', e);
    return false;
  }
}